import {BaseModel} from "../base";
import {BBModel} from "../../bb_model";

class PurchaseCourseBookingModel extends BaseModel {
    constructor(data) {
        super(data);
    }

    getBookings() {
        return new Promise((resolve, reject) => {
            if (this.bookings) {
                resolve(this.bookings);
            }
            if (this._data.$has('bookings')) {
                this._data.$get('bookings').then((bookings) => {
                        this.bookings = ((() => {
                            const result = [];
                            for (const b of Array.from(bookings)) {
                                result.push(new BBModel.Purchase.Booking(b));
                            }
                            return result;
                        })());
                        this.bookings.sort((a, b) => a.datetime.unix() - b.datetime.unix());
                        resolve(this.bookings);
                    }
                );
            } else {
                this.bookings = [];
                resolve(this.bookings);
            }
        });
    }
}

export {
    PurchaseCourseBookingModel
}

